import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Slider} from '@js/components/Slider'
import {Archive} from '@js/components/Archive'
import {Mask} from '@js/animations/Mask'
import {Stagger} from '@js/animations/Stagger'
import {Wipe} from '@js/animations/Wipe'
import {Scroll} from '@js/animations/Scroll'
import {Translate} from '@js/animations/Translate'
import {Shape} from '@js/animations/Shape'
import {Zoom} from '@js/animations/Zoom'
import {CountNumber} from '@js/animations/CountNumber'
import {Mouse} from "./animations/Mouse";

window.onload = () => {

  const animations = [
    Mask,
    Stagger,
    Wipe,
    Scroll,
    Translate,
    Shape,
    Zoom,
    CountNumber,
    Mouse
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Header()
  new Archive()
  new Slider()

}
